import { t } from 'i18next';
import { useFormContext } from 'react-hook-form';

import type { CronJobName } from '../CronJobsCRUDForm.types';

import ControlledNumericField from 'components/shared/ControlledFields/ControlledNumericField';
import { ControlledDatePicker } from 'components/shared/index';

import { JobNameSelect } from '../JobNameSelect';

interface Props {
  selectedJobType?: CronJobName;
  changeJobType: React.Dispatch<React.SetStateAction<CronJobName | undefined>>;
}

export const CleanupFormSection: React.FC<Props> = ({
  selectedJobType,
  changeJobType
}) => {
  const { control, setValue, reset } = useFormContext();

  // Each cleanup exists twice, once for the tenant and once for the whole installation, and the
  // scope is the only thing that tells the two apart - so JobNameSelect labels them, and holds
  // the choice back until it knows which is which.
  const jobNames: CronJobName[] = [
    'bpm-history-cleanup',
    'bpm-execution-cleanup',
    'bpm-history-all-tenants-cleanup',
    'bpm-execution-all-tenants-cleanup'
  ];

  return (
    <>
      <JobNameSelect
        jobNames={jobNames}
        selectedJobType={selectedJobType}
        onSelected={(value) => {
          changeJobType(value);
          setValue('jobName', value);
          reset();
        }}
      />
      {selectedJobType != undefined && (
        <>
          <ControlledNumericField
            name="config.count"
            variant="outlined"
            label={t('cronJobs.form.bpm_cleanup_count')}
          />
          <ControlledNumericField
            name="config.parallelBatches"
            variant="outlined"
            label={t('cronJobs.form.bpm_cleanup_parallel_batches')}
          />
          <ControlledDatePicker
            control={control}
            name="config.cutoffDate"
            variant="outlined"
            label={t('cronJobs.form.bpm_cleanup_cutoff_date')}
          />
          <ControlledNumericField
            name="config.batchSize"
            variant="outlined"
            label={t('cronJobs.form.bpm_cleanup_batch_size')}
          />
          <ControlledNumericField
            name="config.max"
            variant="outlined"
            label={t('cronJobs.form.bpm_cleanup_max')}
          />
          <ControlledNumericField
            name="config.maxTime"
            variant="outlined"
            label={t('cronJobs.form.bpm_cleanup_max_time')}
          />
        </>
      )}
    </>
  );
};

export default CleanupFormSection;
